// src/components/HomePage.js

import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css"; // Import the new CSS file
import logo from "./logo.png"; // adjust the path as per your folder structure

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <div className="home-card">
        {/* Logo */}
        <div className="home-logo">
          <img src={logo} alt="App Logo" className="logo-img" />
        </div>

        <p className="home-tagline">
          Admin Control Panel
        </p>

        {/* Buttons */}
        <div className="home-buttons">
          <button
            className="home-button primary"
            onClick={() => navigate("/EnterLink")}
          >
            Generate QR Code
          </button>
          <button
            className="home-button secondary"
            onClick={() => navigate("/linked-events")}
          >
            Generate Linked Show
          </button>
        </div>
      </div>
    </div>
  );
}
